export default {
  productSpecSheetImages: [],
  productSpecSheetImage: undefined,
};
